module.exports = __webpack_public_path__ + "img/store_pause_icon.d7deb707.svg";